export const OKTA_LOGIN_URL: string = '/oidc/login';